import { useState } from 'react';
import { TOKEN_DISCLAIMER, useTokenWallet } from './api/tokenWallet';

export function TokenChip() {
  const { balance, error, refresh } = useTokenWallet();
  const [refreshing, setRefreshing] = useState(false);
  const reload = () => {
    setRefreshing(true);
    void refresh().finally(() => setRefreshing(false));
  };
  return (
    <button
      type="button"
      className={`sx-chip sx-chip-btn${balance === 0 ? ' sx-chip-neg' : ''}`}
      onClick={reload}
      title={error ? `Couldn't refresh your tokens: ${error}` : `One token is used for each assessment. ${TOKEN_DISCLAIMER}`}
    >
      {balance === null ? <span className="skel" style={{ width: 48 }} /> : (
        <>
          <span style={refreshing ? { visibility: 'hidden' } : undefined}>{`${balance} token${balance === 1 ? '' : 's'}`}</span>
          {refreshing && <span className="skel sx-chip-skel" />}
        </>
      )}
    </button>
  );
}
